import { Reducer, combineReducers } from 'redux'

import userReducer from 'state/reducers/userReducer'
import appReducer from 'state/reducers/appReducer'
import { IRootState } from 'types'

const rootReducer: Reducer<IRootState> = combineReducers({
    user: userReducer,
    app: appReducer,
})

export default rootReducer